<!-- eslint-disable -->
<template lang="pug">
    .olympiad-result-page
        .olympiad-result-page__block(v-if="!isLoading")
            olympiad-box(:backgroundTop="false")
                template(slot="top")
                    div.olympiad-stage__image-block
                        img.olympiad-stage__image(:src="!isTrainer ? stage.level.olympiad.logo : stage.stage.level.olympiad.logo")
                    decorations.olympiad-stage__decorations
                        span(v-text="stage.position + 1 + $i18n.t('olympiads.olympiads_processStage_stageComplete')")
                    result-students-list(
                        :students="students"
                    )
            .olympiad-result-page__exit-button
                router-link(:to="{\
                    name: 'olympiads:start',\
                    params: {\
                        id: !isTrainer ? stage.level.id : stage.stage.level.id, \
                        isTrainer: isTrainer\
                    }\
                }")
                    cs-button(color="white" pattern="primary")
                        | {{ $i18n.t('olympiads.olympiads_processStage_further') }}
        cs-loader(v-else)

</template>

<script>
    /*eslint-disable*/
    import StageApi from './../../api/olympiads/stage'
    import OlympiadBox from './Box.vue'
    import OlympiadPreview from './Preview.vue'
    import Decorations from './Decorations.vue'
    import ResultStudentsList from './ResultStudentsList.vue'
    import _ from 'lodash'
    import TrainerStageApi from '../../api/olympiads/trainerStageApi'

    export default {
        props: {
            id: [Number, String],
            isTrainer: {
                type: Boolean,
                default: false,
            }
        },
        created () {
            this.fetchData()
        },
        methods: {
            fetchData () {
                this.isLoading = true;
                let api = this.isTrainer ? TrainerStageApi : StageApi;
                api.show(this.id)
                .then(data => {
                    this.stage = data;
                    this.stage.completedUsers.forEach(user => {
                        user.pivot.points = +user.pivot.points;
                    });
                    this.students = _.orderBy(
                            this.stage.completedUsers,
                            ['pivot.points', 'pivot.time'],
                            ['desc', 'asc']
                    );
                    this.isLoading = false;
                })
                .catch(e => {
                    this.$toasted.error(this.$root.$t('errors.getting_stage'));
                })
            }
        },
        data() {
            return {
                isLoading: false,
                stage: null,
                students: null
            }
        },
        components: {
            ResultStudentsList,
            OlympiadBox,
            OlympiadPreview,
            Decorations,
        }
    }
</script>

<style lang="scss" scoped>
    .olympiad-result-page {
        margin: 0 auto;
        @include media($lg) {
            width: 80%;
        }
        @include media($xxl) {
            width: 70%;
        }
    }

    .olympiad-stage__image-block {
        display: flex;
        justify-content: center;
        margin-bottom: 20px;
    }

    .olympiad-stage__decorations {
        margin-bottom: 20px;
    }

    .olympiad-result-page__exit-button {
        text-align: center;
    }

    .olympiad-result-page__buttons-container {
        display: flex;
        justify-content: center;
        margin-bottom: 30px;
    }

    .olympiad-result-page__button {
        font-weight: 500 !important;
        .svg-icon {
            margin-right: 5px;
        }
    }
</style>
